export {
  /** @deprecated Use @pflegia/util/common */
  formatName,
  /** @deprecated Use @pflegia/util/common */
  genericFormatName,
} from '@pflegia/util/common/format-name';

export type {
  /** @deprecated Use @pflegia/util/common */
  FullNameType,
} from '@pflegia/util/common/format-name';

export {
  /** @deprecated Use @pflegia/util/common */
  formatNameWithTitles,
  /** @deprecated Use @pflegia/util/common */
  strictFormatNameWithTitles,
} from '@pflegia/util/pflegia/format-name';
